/* Project Import will be here */
import * as actions from '../actions/tab.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    tab: {
        selectedTabName:""
    }
};

/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.TAB_SELECTION:
            return {
                ...state,
                tab: {
                    ...state.tab,                  
                    selectedTabName: action.selectedTabName
                }
            };        

        default:
            return state;
    }
}